/**
 * Created by Ivan on 06.06.2025
 */

const BubblesStackView = cc.Node.extend({
    ctor: function (row) {
        this.row = row;
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.model = row.data;
        const styles = cleverapps.styles.BubblesStackView;
        const bubble = this.bubble = new cleverapps.Spine(bundles.merge.jsons.bubblestack_json);
        this.bubble.setAnimationAndIdleAfter("show_up", "idle");
        this.addChild(bubble);

        if (styles.rays) {
            const bubbleBack = this.bubbleBack = new cleverapps.Spine(bundles.merge.jsons.ready_rays_json);
            bubbleBack.setAnimationAndIdleAfter("show_up", "idle");
            bubble.addChild(bubbleBack, styles.rays.zOrder);
            bubbleBack.setAlignment(bubble.width / 2, bubble.height / 2);
            bubbleBack.setScale(styles.rays.scale);
        }

        if (bundles.merge.jsons.bubble_stack_arrow_json) {
            const arrow = this.arrow = new cleverapps.Spine(bundles.merge.jsons.bubble_stack_arrow_json);
            bubble.addChild(arrow, 1);
            arrow.setAlignment(styles.arrow.positions);
        }

        this.bubbleBackNode = new cc.Node();
        this.bubbleFrontNode = new cc.Node();
        [this.bubbleBackNode, this.bubbleFrontNode].forEach((node) => {
            node.setAnchorPoint(0.5, 0.5);
            node.setContentSize(this.bubble.getContentSize());
            node.setAlignment(this.bubble.width / 2, this.bubble.height / 2);
        });
        this.bubble.addChild(this.bubbleBackNode, styles.unit.zOrder);
        this.bubble.addChild(this.bubbleFrontNode);

        this.onResize();
        this.updateState();
        this.updateVisible();
        this.startAnimate();

        this.model.on("onChangeUnit", this.updateState.bind(this), this);
        this.model.on("updateVisible", this.updateVisible.bind(this), this);

        if (!this.model.top()) {
            this.bubble.setVisible(false);
        }

        cleverapps.UI.onClick(this, () => {
            this.model.pop(this.bubble);
        });

        cleverapps.aims.registerTarget(BubblesStack.ID, this, {
            filter: () => Merge2.current && Merge2.current.mode === Merge2.MODE_GAME,
            withoutDelta: true,
            flyingUnderShadow: true
        });

        this.model.onGetView = this.createListener(() => this);
        this.model.on("spawn", this.spawn.bind(this), this);
    },

    updateUnit: function () {
        const styles = cleverapps.styles.BubblesStackView.unit;
        if (this.unit) {
            this.unit.runAction(new cc.Sequence(
                new cc.ScaleTo(0.1, 0.6),
                new cc.RemoveSelf()
            ));
            this.unit = undefined;
        }

        const unit = this.model.top();
        if (unit) {
            this.unit = UnitView.getUnitImage(unit, {
                defaultAnimation: "unit_info"
            });
            this.bubbleBackNode.addChild(this.unit);
            this.unit.setAlignment(styles);

            this.unit.setVisible(false);
            this.unit.setScale(0.5);
            this.unit.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.Show(),
                new cc.ScaleTo(0.2, styles.scale).easing(cc.easeBackOut())
            ));
        }
    },

    updateState: function () {
        this.updateUnit();
        this.updateAmount();
    },

    updateVisible: function () {
        if (this.model.isVisible()) {
            this.bubble.setVisible(true);
            if (this.bubble.isDisappearing) {
                this.bubble.isDisappearing = false;
                this.bubble.setAnimationAndIdleAfter("show_up", "idle");
                this.bubbleBack && this.bubbleBack.setAnimationAndIdleAfter("show_up", "idle");
            }
        } else {
            this.bubble.setAnimation(0, "disappear", false);
            this.bubbleBack && this.bubbleBack.setAnimation(0, "disappear", false);
            this.bubble.isDisappearing = true;
            this.bubble.setCompleteListenerOnce(() => {
                if (this.bubble.isDisappearing) {
                    this.bubble.setVisible(false);
                }
            });
        }
    },

    createAmount: function (amount) {
        if (this.amountText) {
            this.amountText.setString(amount);
            return;
        }

        const styles = cleverapps.styles.BubblesStackView.amount;
        const amountNode = this.amountNode = new cc.Sprite(bundles.merge.frames.bg_amount_png);
        this.bubbleFrontNode.addChild(amountNode);
        amountNode.setAlignment(styles.node);

        const amountText = this.amountText = cleverapps.UI.generateImageText(amount, cleverapps.styles.FONTS.BUBBLES_STACK_TEXT);
        amountText.fitTo(styles.width);
        amountNode.addChild(amountText);
        amountText.setAlignment(styles);

        amountNode.setScale(0);
        amountNode.runAction(new cc.ScaleTo(0.3, 1).easing(cc.easeBackOut()));
    },

    removeAmount: function () {
        if (!this.amountNode) {
            return;
        }

        this.amountNode.runAction(new cc.Sequence(
            new cc.ScaleTo(0.3, 0).easing(cc.easeBackIn()),
            new cc.RemoveSelf()
        )).setFinalize(() => {
            this.amountNode = undefined;
            this.amountText = undefined;
        });
    },

    updateAmount: function () {
        const elementsAmount = this.model.size();

        if (elementsAmount > 1) {
            this.createAmount(elementsAmount);
        } else {
            this.removeAmount();
        }
    },

    startAnimate: function () {
        if (cleverapps.styles.BubblesStackView.wiggle) {
            [this.bubbleBackNode, this.bubbleFrontNode].filter(Boolean).forEach((node) => {
                node.runAction(StandartAnimations.hovering(node, {
                    animationTime: this.bubble.getAnimationDuration("idle"),
                    offsetY: cleverapps.styles.BubblesStackView.bubbleAnimationNode.offsetY,
                    rightAngle: 0,
                    leftAngle: -10
                }));
            });
        }

        this.bubble.setAnimationAndIdleAfter("show_up", "idle");
        this.bubbleBack && this.bubbleBack.setAnimationAndIdleAfter("show_up", "idle");
    },

    getPositionForFinger: function () {
        return this.unit;
    },

    onResize: function () {
        const styles = cleverapps.styles.BubblesStackView;

        this.bubble.setAlignment(styles.bubble);

        if (this.unit) {
            this.unit.setAlignment(cleverapps.styles.BubblesStackView.unit);
        }
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.bubble.setScale(styles.verticalScale);
        } else {
            this.bubble.setScale(1);
        }

        cleverapps.UI.wrap(this);
        if (this.arrow) {
            const animationName = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? "vertical" : "horizontal";
            if (animationName !== this.arrow.getCurrentAnimationName()) {
                this.arrow.setAnimation(0, animationName, true);
            }
        }
    },

    spawn: function (source, unit) {
        const unitView = new UnitView(new Unit(unit));
        source.addChild(unitView);
        unitView.setAlignment(source.width / 2, source.height / 2);
        unitView.setScale(0.8);
        unitView.setVisible(false);

        const movingNode = cleverapps.Scenes.GetMovingNode();
        const path = new cleverapps.Particles(bundles.particle.jsons.particles_spawn_json, bundles.particle.frames.particle_texture);
        movingNode.addChild(path);
        unitView.replaceParentSamePlace(movingNode);

        const position = movingNode.convertToNodeSpace(this.convertToWorldSpace(cc.p(this.width / 2, this.height / 2)));

        unitView.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                unitView.setVisible(true);
                path.followTarget(unitView);
            }),
            cleverapps.effects.fireAction("rave_reviews.rupor.generator"),
            new cc.Spawn(
                new cc.MoveTo(0.3, position.x, position.y).easing(cc.easeOut(1)),
                new cc.ScaleTo(0.3, 1).easing(cc.easeOut(1))
            ),
            new cc.RemoveSelf()
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BUBBLES_STACK_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.BubblesStackView = {
    wiggle: true,
    verticalScale: 1,
    bubble: {
        x: { align: "center" },
        y: { align: "center" }
    },

    rays: {
        zOrder: -2,
        scale: 0.5
    },

    unit: {
        zOrder: -1,
        x: { align: "center" },
        y: { align: "center", dy: -10 },
        scale: 0.8
    },

    width: 160,
    height: 205,

    bubbleAnimationNode: {
        offsetY: -11
    },

    amount: {
        x: { align: "center" },
        y: { align: "center" },
        width: 35,
        node: {
            x: { align: "right", dx: 2 },
            y: { align: "top", dy: 2 }
        }
    },

    arrow: {
        positions: [
            { x: { align: "right", dx: 17 }, y: { align: "bottom", dy: 0 } },
            { x: { align: "left", dx: -2 }, y: { align: "bottom", dy: -12 } },
            { x: { align: "left", dx: -2 }, y: { align: "bottom", dy: -12 } }
        ]
    }
};